import { render, staticRenderFns } from "./AvaliationBooleanChart.vue?vue&type=template&id=60733fdc"
import script from "./AvaliationBooleanChart.vue?vue&type=script&lang=js"
export * from "./AvaliationBooleanChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports